import type { BoxSessionFormikEntity } from "@/modules/boxSlotSession/entities/boxSessionFormikEntity"
import type {
  ProgramInfiniteSessionFormikType,
  ProgramOnOffSessionFormikType,
  ProgramSessionInputKey,
} from "@/modules/sessions/programSessionFormikType"
import { SessionBlockType } from "@/modules/sessions/sessionDetails/sessionBlockTypes"
import { ExerciseExistingBloc } from "@/modules/sessions/sessionForm/blocks/exerciseBlock/components/exerciseExistingBloc"
import { MediaExistingBloc } from "@/modules/sessions/sessionForm/blocks/mediaBlock/components/mediaExistingBloc"
import { NoteForAthletesExistingBloc } from "@/modules/sessions/sessionForm/blocks/noteBlock/components/noteForAthletesExistingBloc"
import { NoteForCoachesExistingBloc } from "@/modules/sessions/sessionForm/blocks/noteBlock/components/noteForCoachesExistingBloc"
import { type SessionBlockFormikType } from "@/modules/sessions/sessionForm/sessionBlockFormikTypes"
import type { SimpleFormik } from "@/typings/formik"
import { useCallback } from "react"

type Props = {
  formik:
    | SimpleFormik<BoxSessionFormikEntity, ProgramSessionInputKey>
    | SimpleFormik<ProgramInfiniteSessionFormikType, ProgramSessionInputKey>
    | SimpleFormik<ProgramOnOffSessionFormikType, ProgramSessionInputKey>
  block: SessionBlockFormikType
  blockIndex: number
  showTemplateActions?: boolean
} & React.ComponentProps<"div">

export function ExistingBlock({ formik, block, blockIndex, showTemplateActions, ...props }: Props) {
  const moveBlock = useCallback(
    async (blockIndex: number, direction: "UP" | "DOWN") => {
      const directionShift = direction === "UP" ? -1 : 1
      if (blockIndex >= 0) {
        // if block index is find
        const newBlocksArray = [...formik.values.blocks] // copy the array
        const tmp = newBlocksArray[blockIndex] // save block at the index we ant to move
        const tmp2 = newBlocksArray[blockIndex + directionShift] //save block we shift
        if (!tmp || !tmp2) return

        newBlocksArray[blockIndex + directionShift] = tmp // save the block at his new position
        newBlocksArray[blockIndex] = tmp2 // save the shift block at his new position
        await formik.setFieldValue("blocks", newBlocksArray, false).catch((e: unknown) => {
          console.error("formik error", e)
        }) //update formik 'blocks' value
      }
    },
    [formik],
  )

  const deleteBlock = useCallback(
    async (blockIndex: number) => {
      const blocks = [...formik.values.blocks.filter((_, index) => blockIndex !== index)]
      await formik.setFieldValue("blocks", blocks)
    },
    [formik],
  )

  return (
    <div {...props}>
      {/* Block content */}
      {block.type === SessionBlockType.SESSION_EXERCISE ? (
        <ExerciseExistingBloc
          formik={formik}
          block={block}
          blockIndex={blockIndex}
          moveBlock={moveBlock}
          deleteBlock={deleteBlock}
          showTemplateActions={showTemplateActions}
        />
      ) : block.type === SessionBlockType.COACH_NOTE ? (
        <NoteForCoachesExistingBloc
          formik={formik}
          block={block}
          blockIndex={blockIndex}
          moveBlock={moveBlock}
          deleteBlock={deleteBlock}
        />
      ) : block.type === SessionBlockType.MEDIAS ? (
        <MediaExistingBloc
          formik={formik}
          block={block}
          blockIndex={blockIndex}
          moveBlock={moveBlock}
          deleteBlock={deleteBlock}
        />
      ) : (
        <NoteForAthletesExistingBloc
          formik={formik}
          block={block}
          blockIndex={blockIndex}
          moveBlock={moveBlock}
          deleteBlock={deleteBlock}
        />
      )}
    </div>
  )
}
